<template>
  <v-dialog
      :value="cambia"
      persistent
  >
    <v-card>
        <v-card-text >
          <v-dialog v-model="dialogdelete" persistent max-width="350">
            <v-card>
              <v-card-title class="headline">Desea eliminar esta Persona de la Lista?</v-card-title>
              <v-card-text>Estos datos no se volveran a visualizar en el sistema.</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" text @click="dialogdelete = false">No</v-btn>
                <v-btn color="primary darken-1" text @click="borralo">SI</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-row align="center" class="text-center">
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-autocomplete  v-model="fiestaid" :items="fiestas" item-value="id" item-text="nombre"  @change="damelistas" persistent-hint

                               single-line label="Escoger Fiesta"></v-autocomplete>
            </v-col>
          </v-row>

          <v-row >
            <v-col cols="12" sm="12" md="12" lg="12">

              <v-data-table
                      v-if="promotor.qrlista"
                  :headers="headersQr"
                  :items="listas"
                  sort-by="listaFiesta.fiesta.fechaInicio"
                  sort-desc
                  class="elevation-1"
                  :search="search"
                  no-data-text="No hay datos disponibles para mostrar."
                  no-results-text="No hay resultados para la búsqueda."
                  loading-text="Cargando... Por favor espere."
                  :header-props="headerProps"
                  :footer-props="footerProps"
              >
                <template v-slot:top>
                  <v-toolbar flat >
                    <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-icon
                      small
                      color="primary"
                      class="mr-2"
                      @click="editItem(item)"
                  >
                    fas fa-edit
                  </v-icon>
                  <v-icon
                      small
                      class="mr-2"
                      color="error"
                      @click="deleteItem(item)"
                  >
                    fas fa-minus-circle
                  </v-icon>
                    <v-icon
                            v-if="item.qr === true && item.idPersona > 0"
                            small
                            color="white"
                            class="mr-2"
                            @click="verQr(item)"
                    >
                        fas fa-qrcode
                    </v-icon>
                </template>

              </v-data-table>
                <v-data-table
                        v-else
                        :headers="headers"
                        :items="listas"
                        sort-by="listaFiesta.fiesta.fechaInicio"
                        sort-desc
                        class="elevation-1"
                        :search="search"
                        no-data-text="No hay datos disponibles para mostrar."
                        no-results-text="No hay resultados para la búsqueda."
                        loading-text="Cargando... Por favor espere."
                        :header-props="headerProps"
                        :footer-props="footerProps"
                >
                    <template v-slot:top>
                        <v-toolbar flat >
                            <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
                        </v-toolbar>
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                        <v-icon
                                small
                                color="primary"
                                class="mr-2"
                                @click="editItem(item)"
                        >
                            fas fa-edit
                        </v-icon>
                        <v-icon
                                small
                                class="mr-2"
                                color="error"
                                @click="deleteItem(item)"
                        >
                            fas fa-minus-circle
                        </v-icon>

                    </template>

                </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      <v-card-actions>
        <v-row>
        <v-col>
          <v-btn text color="white"  @click="$emit('cierra')">Cerrar</v-btn>
        </v-col></v-row>
      </v-card-actions>
    </v-card>
        <v-overlay :value="overlay">
          <v-img
              src="@/assets/loadtunay.gif"

          />
        </v-overlay>
  </v-dialog>
</template>

<script>
import axios from "axios";
export default {
  name: "milista",
  components: {

  },
  props:{
    promotor:{
      "id":1,
      "promotorNombre":"Nombre"
    },
    fiestas:[],
    cambia: Boolean
  },
  data () {
    return{
      md5promo: '',
      overlay:false,
      alertnuevo:false,
      logoexist: false,
      logoimg: null,
      progr:false,
      dialogdelete:false,
      fiestaid:0,
      headerProps: {
        sortByText: "Ordenar por"
      },
      footerProps: {
        itemsPerPageText: "Items por página"
      },
      search: '',
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      listas:[],
      headers: [
        { text: 'Acciones', value: 'action', sortable: false },
        { text: 'Fiesta', align: 'left',  value: 'nombreActo'},
        { text: 'Fecha Ingreso', value: 'fechaIngreso' },
        { text: 'Nombre', value: 'nombre' },
        { text: 'Tipo de Lista', value: 'tipoLista'},
      ],
        headersQr: [
            { text: 'Acciones', value: 'action', sortable: false },
            { text: 'Fiesta', align: 'left',  value: 'nombreActo'},
            { text: 'Fecha Ingreso', value: 'fechaIngreso' },
            { text: 'Nombre', value: 'nombre' },
            { text: 'Tipo de Lista', value: 'tipoLista'},
            { text: 'Codigo para Registro', value: 'codigoUnico'},
        ],
    }
  },
  mounted (){
    if(this.fiestas.length>0){
    this.fiestaid = this.fiestas[0].id
    this.damelistas();}
  },
  methods:{
    editItem (item) {
      this.editedIndex = this.listas.indexOf(item)
      this.lista = Object.assign({}, item)
      this.editedItem.listaFiesta.fiesta.fiestaInicio = this.formatDate(new Date(this.editedItem.listaFiesta.fiesta.fiestaInicio))
      this.editedItem.dateCreated = this.formatDateee(new Date(this.editedItem.dateCreated))
      this.dialog = true
    },
    deleteItem (item) {
      this.editedIndex = this.listas.indexOf(item);
      this.dialogdelete = true;
    },
      verQr (item) {
          let ssalink = "https://tunay.app/eqr/"+item.codigoUnico
          var anchor = document.createElement('a');
          anchor.href = ssalink;
          anchor.target="_blank";
          anchor.click();
      },
    damelistas(){
      this.overlay = true;
      var bodyFormData = new FormData();
      bodyFormData.append("fiestaId",this.fiestaid)
      bodyFormData.append("promotorId",this.promotor.id)
      axios
      .post("lista/fiesta/promotor",bodyFormData)
      .then(response =>{
          this.listas = response.data
        this.overlay = false;
      })
          .catch((error)  => {
            console.error(error);
            this.overlay = false;
          });
    },
  }
}
</script>
